import React from "react";
import useResponsive from "../../core/hooks/useResponsive";
import { ThreeRow, TwoRow } from "../../core/layouts";
import ThreeColumn from "../../core/layouts/ThreeColumn";
import variables from "../../themes/base/styles/variables";
import { getValueOnCondition } from "../../UtilityFunctions/utils";

const viewUserRoleDetailsLayoutStyle = {
  userRoleDetailsWrapperStyle: {
    gap: variables.gapMedium2,
  },
  columnsStyle: {
    flex: 1,
  },
  userDetailsColumnContainerStyle: {
    display: variables.dFlex,
    gap: variables.gapSmall,
  },

  userRoleDetailsMobileWrapperStyle: {
    gap: variables.gapSmall,
  },
};

export default function ViewUserRoleDetailsLayout({ //NOSONAR
  roleNameSection,
  employeeIdSection,
  countrySection,
  globalIdSection,
  auditSectionTM,
  auditSectionDNSD,
  onlyDNSDRoleSelected,
  isTMRoleIncluded,
  isDNSDRoleIncluded,
}) {
  const responsive = useResponsive();

  return responsive?.isSm ? (
    <TwoRow
      style={viewUserRoleDetailsLayoutStyle.userRoleDetailsWrapperStyle}
      topSection={
        <ThreeColumn
          style={viewUserRoleDetailsLayoutStyle.userDetailsColumnContainerStyle}
          leftSection={roleNameSection}
          middleSection={getValueOnCondition({
            condition: onlyDNSDRoleSelected,
            trueValue: globalIdSection,
            falseValue: employeeIdSection,
          })}
          rightSection={countrySection}
          leftSectionStyle={viewUserRoleDetailsLayoutStyle.columnsStyle}
          middleSectionStyle={viewUserRoleDetailsLayoutStyle.columnsStyle}
          rightSectionStyle={viewUserRoleDetailsLayoutStyle.columnsStyle}
        />
      }
      bottomSection={
        (isTMRoleIncluded || isDNSDRoleIncluded) && (
          <ThreeColumn
            leftSection={getMDLeftMBTopSection(
              onlyDNSDRoleSelected,
              auditSectionDNSD,
              isTMRoleIncluded,
              auditSectionTM,
              globalIdSection
            )}
            middleSection={getMiddleSection(
              onlyDNSDRoleSelected,
              isDNSDRoleIncluded,
              isTMRoleIncluded,
              auditSectionDNSD,
              globalIdSection
            )}
            rightSection={isTMRoleIncluded && auditSectionDNSD}
            style={
              viewUserRoleDetailsLayoutStyle.userDetailsColumnContainerStyle
            }
            leftSectionStyle={viewUserRoleDetailsLayoutStyle.columnsStyle}
            middleSectionStyle={viewUserRoleDetailsLayoutStyle.columnsStyle}
            rightSectionStyle={viewUserRoleDetailsLayoutStyle.columnsStyle}
          />
        )
      }
    />
  ) : (
    <TwoRow
      style={viewUserRoleDetailsLayoutStyle.userRoleDetailsMobileWrapperStyle}
      topSection={
        <ThreeRow
          style={
            viewUserRoleDetailsLayoutStyle.userRoleDetailsMobileWrapperStyle
          }
          topSection={roleNameSection}
          middleSection={getValueOnCondition({
            condition: onlyDNSDRoleSelected,
            trueValue: globalIdSection,
            falseValue: employeeIdSection,
          })}
          bottomSection={countrySection}
        />
      }
      bottomSection={
        (isTMRoleIncluded || isDNSDRoleIncluded) && (
          <ThreeRow
            style={
              viewUserRoleDetailsLayoutStyle.userRoleDetailsMobileWrapperStyle
            }
            topSection={getMDLeftMBTopSection(
              onlyDNSDRoleSelected,
              auditSectionDNSD,
              isTMRoleIncluded,
              auditSectionTM,
              globalIdSection
            )}
            middleSection={getMiddleSection(
              onlyDNSDRoleSelected,
              isDNSDRoleIncluded,
              isTMRoleIncluded,
              auditSectionDNSD,
              globalIdSection
            )}
            bottomSection={isTMRoleIncluded && auditSectionDNSD}
          />
        )
      }
    />
  );
}

function getMiddleSection(
  onlyDNSDRoleSelected,
  isDNSDRoleIncluded,
  isTMRoleIncluded,
  auditSectionDNSD,
  globalIdSection
) {
  if (onlyDNSDRoleSelected) {
    return <></>;
  } else if (isDNSDRoleIncluded && !isTMRoleIncluded) {
    return auditSectionDNSD;
  } else {
    return globalIdSection;
  }
}

function getMDLeftMBTopSection(
  onlyDNSDRoleSelected,
  auditSectionDNSD,
  isTMRoleIncluded,
  auditSectionTM,
  globalIdSection
) {
  let section;

  if (onlyDNSDRoleSelected) {
    section = auditSectionDNSD;
  } else if (isTMRoleIncluded) {
    section = auditSectionTM;
  } else {
    section = globalIdSection;
  }
  return section;
}
